import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './App.css';
import DraftList from './components/DraftList';
import DraftModal from './components/DraftModal';

function App() {
  const [drafts, setDrafts] = useState([]);
  const [selectedDraft, setSelectedDraft] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);

  // Fetch drafts on mount and when refreshKey changes
  useEffect(() => {
    fetchDrafts();
  }, [refreshKey]);

  const fetchDrafts = async () => {
    try {
      setLoading(true);
      const response = await axios.get('/api/drafts');
      setDrafts(response.data.drafts || []);
      setError(null);
    } catch (err) {
      setError(`Failed to fetch drafts: ${err.message}`);
      console.error('Error:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleDraftClick = (draft) => {
    setSelectedDraft(draft);
  };

  const handleCloseModal = () => {
    setSelectedDraft(null);
  };

  const handleRefresh = () => {
    setRefreshKey(prev => prev + 1);
  };

  if (loading) {
    return (
      <div className="app">
        <div className="loading">Loading drafts...</div>
      </div>
    );
  }

  return (
    <div className="app">
      <header className="app-header">
        <div className="header-content">
          <h1>📬 AIA Inbox Approval</h1>
          <p className="subtitle">Review and approve draft messages</p>
        </div>
        <div className="header-actions">
          <button onClick={handleRefresh} className="refresh-btn">
            ↻ Refresh
          </button>
        </div>
      </header>

      {error && (
        <div className="error-banner">
          <span>⚠️ {error}</span>
          <button onClick={() => setError(null)}>Dismiss</button>
        </div>
      )}

      <main className="app-main">
        {drafts.length === 0 ? (
          <div className="empty-state">
            <div className="empty-icon">✓</div>
            <h2>All caught up!</h2>
            <p>No pending drafts to review.</p>
          </div>
        ) : (
          <DraftList
            drafts={drafts}
            onSelectDraft={handleDraftClick}
            draftCount={drafts.length}
          />
        )}
      </main>

      {selectedDraft && (
        <DraftModal
          draft={selectedDraft}
          onClose={handleCloseModal}
          onRefresh={handleRefresh}
        />
      )}
    </div>
  );
}

export default App;
